export default __webpack_public_path__ + "static/media/gif-en.662183a4.m4v";